import A from './ui/A';
import { FaBars } from 'react-icons/fa';

import Logo from './Logo';
import CurrentUserAvatarMenu from './CurrentUserAvatarMenu';
import { useState } from 'react';
import { useRouter } from 'next/router';

export default ({ logoSize = 'xs', logoOnly, onLogoClick = undefined }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useRouter();
  const handleMenuClick = () => setMenuOpen(!menuOpen);
  const options = [
    { route: '/features', label: 'Features' },
    { route: '/pricing', label: 'Pricing' },
    { route: '/examples', label: 'Example' },
    { route: '/support', label: 'Support' },
  ];
  return (
    <nav className="flex flex-wrap items-center justify-between">
      <div className="w-16 sm:hidden"></div>
      <div className="flex items-center flex-shrink-0 sm:mr-6">
        <div className="flex justify-center cursor-pointer">
          {onLogoClick ? (
            <Logo look="right" logoOnly={logoOnly} logoSize={logoSize} />
          ) : (
            <A href="/">
              <Logo look="right" logoOnly={logoOnly} logoSize={logoSize} />
            </A>
          )}
        </div>
      </div>
      <div className="block w-16 lg:hidden">
        <button onClick={handleMenuClick} className="flex items-center px-3 py-2 mx-3 ">
          <FaBars />
        </button>
      </div>
      <div
        className={`flex-grow w-full divide-x divide-gray-200 lg:flex lg:items-center lg:w-auto ${
          menuOpen ? 'block' : 'hidden'
        }`}
      >
        <div className="flex flex-col items-end justify-end lg:items-center lg:flex-row lg:flex-grow">
          {options.map(option => (
            <div key={option.route} className="px-3 py-2">
              <A href={option.route}>
                <span
                  className={`py-2 px-1 text-black ${option.route === pathname ? 'border-b-2' : ''}
              `}
                >
                  {option.label}
                </span>
              </A>
            </div>
          ))}
          <div className="px-2 my-2">
            <CurrentUserAvatarMenu />
          </div>
        </div>
      </div>
    </nav>
  );
};
